export default function getGeoLocation() : Promise<any> {
  return new Promise((resolve, reject) => {
    const successCallback = (position) => {
      const latlong = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      resolve(latlong);
    };

    const errorCallback = (err) => {
      reject(err);
    };

    if (!navigator.geolocation) {
      errorCallback('Geolocation is not supported by your browser');
    } else {
      navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
    }
  });
}
